module.exports = __webpack_public_path__ + "img/log_in_icon_dashboard_white.3d4bbd82.svg";